"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureFlags = void 0;
exports.FeatureFlagsInit = FeatureFlagsInit;
var _react = require("react");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var FeatureFlags = /*#__PURE__*/function () {
  function FeatureFlags() {
    _classCallCheck(this, FeatureFlags);
  }
  _createClass(FeatureFlags, null, [{
    key: "init",
    value: function init() {
      if (!window.HMS) {
        window.HMS = {};
      }
      // unsubscribe for muted audio tracks
      window.HMS.AUDIO_SINK = false;
      // some extra config to hls js to bring down latency
      window.HMS.OPTIMISE_HLS_LATENCY = false;
      // ask permissions in preview even if role doesn't have it
      window.HMS.ALWAYS_REQUEST_PERMISSIONS = false;
      // add support for server degradation
      window.HMS.FREEZE_VIDEO_LIST = false; // process.env.REACT_APP_ENV === "qa";
      window.HMS.SHOW_NS = process.env.REACT_APP_ENV !== "prod";
    }
  }, {
    key: "showNS",
    value: function showNS() {
      return window.HMS.SHOW_NS;
    }
  }, {
    key: "freezeVideoList",
    value: function freezeVideoList() {
      return window.HMS.FREEZE_VIDEO_LIST;
    }
  }, {
    key: "optimiseHLSLatency",
    value: function optimiseHLSLatency() {
      return window.HMS.OPTIMISE_HLS_LATENCY;
    }
  }, {
    key: "alwaysRequestPermissions",
    value: function alwaysRequestPermissions() {
      return window.HMS.ALWAYS_REQUEST_PERMISSIONS;
    }
  }]);
  return FeatureFlags;
}();
exports.FeatureFlags = FeatureFlags;
_defineProperty(FeatureFlags, "enableTranscription", process.env.REACT_APP_ENABLE_TRANSCRIPTION === "true");
_defineProperty(FeatureFlags, "enableStatsForNerds", process.env.REACT_APP_ENABLE_STATS_FOR_NERDS === "true");
_defineProperty(FeatureFlags, "enableWhiteboard", process.env.REACT_APP_ENABLE_WHITEBOARD && process.env.REACT_APP_PUSHER_APP_KEY && process.env.REACT_APP_PUSHER_AUTHENDPOINT);
function FeatureFlagsInit() {
  (0, _react.useEffect)(function () {
    FeatureFlags.init();
  }, []);
  return null;
}